import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Select from '../../../../components/Select'

import useStyles from './styles'

const YearFilter = ({ selectedYear, setSelectedYear }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const yearsOptions = useMemo(() => {
    // generate years from 2000 to current year
    const currentYear = new Date().getFullYear()
    return Array.from({ length: currentYear - 2000 + 1 }, (_, i) => {
      const year = (2000 + i).toString()
      return { value: year, label: year }
    })
  }, [])

  const clearInputHandler = useCallback(() => {
    setSelectedYear(null)
  }, [setSelectedYear])

  const onChangeHandler = useCallback(
    option => {
      setSelectedYear(option.value)
    },
    [setSelectedYear]
  )

  return (
    <Select
      className={classes.yearFilter}
      isThickBorder={true}
      isSmall={true}
      options={yearsOptions}
      isSearchable={false}
      value={selectedYear}
      onChange={onChangeHandler}
      placeholder={t('Year')}
      showClearInputIcon={!!selectedYear}
      onClearInput={clearInputHandler}
    />
  )
}

YearFilter.propTypes = {
  selectedYear: PropTypes.string,
  setSelectedYear: PropTypes.func.isRequired
}

export default YearFilter
